
import { plainToClass } from "class-transformer";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import Pregunta from "@/models/Sobrevivencia/Pregunta";
import SobrevivenciaService from "@/services/SobrevivenciaService";
import Question from "@/components/sobrevivencia/Question.vue";
import VeeValidateForm from "@/vee-validate/types/VeeValidateForm";
import ServiceResponseFormulario from "@/services/response-models/ServiceResponseFormulario";
import DatosBeneficiario from "@/components/sobrevivencia/DatosBeneficiario.vue";
import { Accordion, AccordionItem } from "@/components/Accordion";
import axios, { AxiosResponse } from "axios";
import FormularioRespuesta from "@/models/Sobrevivencia/Formulario/FormularioRespuesta";
import SaveFormularioRequest from "@/models/Sobrevivencia/Formulario/SaveFormularioRequest";
import EliminarBeneficiarioRequest from "@/models/Sobrevivencia/Formulario/EliminarBeneficiario";
import Swal from "sweetalert2";
import User from "@/models/User";
import { Route } from "vue-router";
@Component({
  components: { Question, DatosBeneficiario, Accordion, AccordionItem },
})
export default class Formulario extends Vue {
  @Prop({ default: false }) isBeneficiarioForm: boolean;
  @Prop({}) triggerFormularioCollection: boolean;
  @Prop({ default: 0 }) openBeneficiario: number;
  @Getter("user") user: User;
  show: boolean = true;
  public sobrevivenciaService: SobrevivenciaService =
    new SobrevivenciaService();
  public Formulario: ServiceResponseFormulario =
    new ServiceResponseFormulario();
  public SaveFormularioRequest = new SaveFormularioRequest();
  public numeroSolicitud: number = 0;
  public isLoading: boolean = true;

  async created() {}

  async mounted() {
    await this.getNumeroSolicitud();
    await this.getFormulario();  
  }

  public async getFormulario() {
    await this.sobrevivenciaService
      .getFormulario(
        this.isBeneficiarioForm,
        this.numeroSolicitud,
        this.user.cedula
      )
      .then((resp) => {
        this.Formulario = resp.data;
      })
      .catch((error) => {
        // console.log(error);
      }).finally(() => {
        this.isLoading = false;
      this.$emit('formularioLoaded');
    });;
  }
  addBeneficiario() {
    let beneficiarioCopy = JSON.parse(
      JSON.stringify(
        this.Formulario.data.children[0].children[
          this.Formulario.data.children[0].children.length - 1
        ]
      )
    ) as Pregunta;

    beneficiarioCopy.id = beneficiarioCopy.id + this.getRandomInt(5888);
    beneficiarioCopy.text = "Nuevo Beneficiario";
    beneficiarioCopy = this.setReiterativeIdBeneficiario(beneficiarioCopy);
    this.Formulario.data.children[0].children.push(beneficiarioCopy);
  }
  setReiterativeIdBeneficiario(beneficiario: Pregunta) {
    beneficiario.children.forEach((item) => {
      item.idReiterativo = item.idReiterativo + 1;
      item.responseValue = null;
      if (item.children.length > 0) {
        this.setReiterativeIdBeneficiario(item);
      }
    });
    return beneficiario;
  }
  async ValidateForm() {
    const isValid = await (
      this.$refs.MainObserver as VeeValidateForm
    ).validate();
    //alert(isValid);
    // console.log(isValid);
    if (!isValid) {
      // console.log(isValid);
      //  alert(isValid)
    }
  }
  public getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }
  removeBeneficiario(id: number) {
    let index = this.Formulario.data.children[0].children.findIndex(
      (x) => x.id == id
    );
    this.Formulario.data.children[0].children.splice(index, 1);
  }
  public async showDeleteAlert(
    id: number,
    parentId: number,
    idReiterativo: number
  ) {
    Swal.fire({
      text: "Desea eliminar este beneficiario/a?",

      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#ED8B2F",
      cancelButtonColor: "#0F6CbC",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let requestEliminar = new EliminarBeneficiarioRequest();
        requestEliminar.codUsuario = this.user.cedula;
        requestEliminar.numPreSolicitud = this.numeroSolicitud;
        requestEliminar.parentId = parentId;
        requestEliminar.idReiterativo = idReiterativo;

        await this.sobrevivenciaService
          .eliminarBeneficiario(requestEliminar)
          .then((resp) => {
            if (resp.data.code == 200) {
              Swal.fire({
                icon: "success",
                allowOutsideClick: false,
                showConfirmButton: false,
                timer: 1000,
              }).then((result) => {
                this.removeBeneficiario(id);
              });
            } else {
            }
          })
          .catch((error) => {});
      }
    });
  }

  public isPredeterminado(value: string): boolean {
    return value.includes("Pre-establecidos");
  }

  public async fillSaveRequest(pregunta: Pregunta) {
    pregunta.children.forEach((element) => {
      if (element.type == "TEXT" || element.type == "SELECT") {
        if (
          !this.SaveFormularioRequest.data.some(
            (x) => x.idPregunta == element.id
          )
        ) {
          //si la pregunda no ha sido editada ,la agrega.
          let newResponse: FormularioRespuesta = new FormularioRespuesta(
            this.numeroSolicitud,
            element.id,
            element.responseValue,
            element.idReiterativo
          );
          this.SaveFormularioRequest.data.push(newResponse);
        }
      }
      if (element.children.length > 0) {
        this.fillSaveRequest(element);
      }
    });

    //this.$emit('collectedResponses', this.SaveFormularioRequest);
  }
  public async collectResponses(pregunta: Pregunta) {
    // console.log("formulario 254");
    await this.fillSaveRequest(pregunta);
    this.$emit("collectedResponses", this.SaveFormularioRequest);
    // this.SaveFormularioRequest.data=[];
  }

  @Watch("triggerFormularioCollection")
  public triggerFormularioCollectionWatch() {
    // console.log("formulario 261");
    this.collectResponses(this.Formulario.data);
  }

  public async getNumeroSolicitud() {
    if (this.$route.query.numeroSolicitud) {
      this.numeroSolicitud = Number(this.$route.query.numeroSolicitud);
      if (this.numeroSolicitud) {
        //this.isEditing = true;
        // this.loadingData = true;
      }
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  async onUrlChange(newVal: Route) {
    // console.log("routeHaschange");
    // console.log("ROUTE-----------=");
    // console.log(newVal);
    await this.getNumeroSolicitud();
    await this.getFormulario();
  }

  public newResponseRecieved(value: FormularioRespuesta) {
    // console.log(
    //   "---------------RECIVED RESPOSNE for pregunta " +
    //     value.idPregunta +
    //     "value:" +
    //     value.ResponseValue
    // );

    value.numPresolicitud = this.numeroSolicitud;
    if (
      this.SaveFormularioRequest.data.some(
        (item) =>
          item.idPregunta == value.idPregunta &&
          item.idReiterativo == value.idReiterativo
      )
    ) {
      //var index = this.SaveFormularioRequest.data.map((item,index) => { } ) ;
      var index = this.SaveFormularioRequest.data.findIndex(
        (item) =>
          item.idPregunta == value.idPregunta &&
          item.idReiterativo == value.idReiterativo
      )
      // console.log(index)
      this.SaveFormularioRequest.data[index] = value;
      // console.log(
      //   "pregunta encontrada y editada" +
      //     SaveFormularioRequest[index].idPregunta +
      //     ":" +
      //     SaveFormularioRequest[index].ResponseValue
      // );
    } else {
      // console.log("no se encontro");
      this.SaveFormularioRequest.data.push(value);
      // console.log(
      //   "no encontrada y agregada" +
      //     value.idPregunta +
      //     ":" +
      //     value.ResponseValue
      // );
    }
    // console.log(this.SaveFormularioRequest.data);
  }

  @Watch("openBeneficiario")
  public open(value, value2) {
    this.openBeneficiario = value;
    // console.log("Formulario recibe" + value + "--" + value2);
    this.OpenBeneficiario(value);
  }
  public OpenBeneficiario(value) {
    let lala = document.getElementById(value);
    document.getElementById(value).click();
  }
}
